module.exports = __webpack_public_path__ + "static/media/16_rauha-oikeudenmukaisuus-ja-hyva-hallinto_en_US.9c10433f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/16_rauha-oikeudenmukaisuus-ja-hyva-hallinto_en_US.svg
// module id = ./src/images/agendaIcons/16_rauha-oikeudenmukaisuus-ja-hyva-hallinto_en_US.svg
// module chunks = 1